import { render, staticRenderFns } from "./SourceChooseWidget.vue?vue&type=template&id=ec456f3e&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./SourceChooseWidget.vue?vue&type=script&lang=js&"
export * from "./SourceChooseWidget.vue?vue&type=script&lang=js&"
import style0 from "./SourceChooseWidget.vue?vue&type=style&index=0&id=ec456f3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec456f3e",
  null
  
)

export default component.exports